
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from 'context/TenantContext';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const ProtectedRoute = (props) => {
    const { component: Component, requireTenant = true } = props;
    const [isValidating, setIsValidating] = useState(true);
    const navigate = useNavigate();
    const tenant = useTenant();
    const maxTimeoutRef = useRef(null);

    useEffect(() => {
        const login = localStorage.getItem('authToken');

        if (!login) {
            // Stash where the operator was trying to go so the login
            // success handler can bounce them back after auth. Used
            // today by the LCP Inspection PWA (/lcpinspectionapp/*) so
            // a "Add to Home Screen" launch that hits the login wall
            // still lands the user on their PWA page after signing in.
            // Same-origin only — the login handler validates the value
            // starts with a safe path prefix before honoring it.
            try {
                const here = window.location.pathname + window.location.search;
                if (here && here !== '/login') {
                    sessionStorage.setItem('postLoginRedirect', here);
                }
            } catch (_e) {
                /* private mode / quota — ignore */
            }
            navigate('/login');
            return;
        }

        if (requireTenant && tenant && !tenant.isValid) {
            const timeout = setTimeout(() => {
                setIsValidating(false);
            }, 500);

            return () => clearTimeout(timeout);
        }

        setIsValidating(false);
    }, [navigate, tenant, requireTenant]);

    // Safety net: never stay in validating state longer than 5 seconds
    useEffect(() => {
        if (isValidating) {
            maxTimeoutRef.current = setTimeout(() => {
                setIsValidating(false);
            }, 5000);
        }
        return () => {
            if (maxTimeoutRef.current) clearTimeout(maxTimeoutRef.current);
        };
    }, [isValidating]);

    if (isValidating) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return Component;
};

export default ProtectedRoute;
